import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { LogOut, User2 } from "lucide-react";
import { signOut } from "firebase/auth";

import { auth } from "../../firebase";
import { useCurrentUser } from "../../hooks/useCurrentUser";

const SideMenu: React.FC = () => {
  const location = useLocation();

  const { currentUser, isCurrentUserLoading } = useCurrentUser();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log("ログアウトしました");
    } catch (error) {
      console.error("ログアウト失敗:", error);
    }
  };

  return (
    <aside className="side-menu">
      <div className="menu-top">
        <h3 className="logo">JBC管理画面</h3>

        <nav>
          <ul>
            <li key="groups">
              <NavLink
                to="/admin/groups"
                className={
                  location.pathname === "/admin/groups" ? "active" : ""
                }
              >
                エントリー
              </NavLink>
            </li>
            {!isCurrentUserLoading && currentUser?.judge === true && (
              <li key="results">
                <NavLink
                  to="/admin/results"
                  className={
                    location.pathname === "/admin/results" ? "active" : ""
                  }
                >
                  採点
                </NavLink>
              </li>
            )}
            {!isCurrentUserLoading && currentUser?.judge === true && (
              <li key="average">
                <NavLink
                  to="/admin/average"
                  className={
                    location.pathname === "/admin/average" ? "active" : ""
                  }
                >
                  アベレージ
                </NavLink>
              </li>
            )}
            <li key="judging-sheet">
              <NavLink
                to="/admin/judging-sheet"
                className={
                  location.pathname === "/admin/judging-sheet" ? "active" : ""
                }
              >
                採点用紙
              </NavLink>
            </li>

            <li key="summary">
              <NavLink
                to="/admin/summary"
                className={
                  location.pathname === "/admin/summary" ? "active" : ""
                }
              >
                基本情報
              </NavLink>
            </li>

            <li key="group-portal">
              <NavLink
                to="/admin/group-portal"
                className={
                  location.pathname === "/admin/group-portal" ? "active" : ""
                }
              >
                グループ
              </NavLink>
            </li>

            <li key="users">
              <NavLink
                to="/admin/users"
                className={location.pathname === "/admin/users" ? "active" : ""}
              >
                ユーザー
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>

      <div>
        {currentUser && (
          <p className="account-name flex">
            <span
              className={`account-name flex ${
                currentUser.role === "adminMaster" ? "master" : "user"
              }`}
            >
              <User2 size={18} style={{ marginRight: "6px" }} />
              {currentUser.name}
            </span>
          </p>
        )}

        <p className="logout" onClick={handleLogout}>
          <LogOut size={18} />
          ログアウト
        </p>
      </div>
    </aside>
  );
};

export default SideMenu;
